<template>
  <div>
    <v-layout
      row
      align-center
      mb-2
    >
      <v-flex xs1>
        <span :style="nameStyle">{{ item.quantity }}x</span>
      </v-flex>
      <v-flex xs9>
        <span class="name" :style="titleStyle">{{ itemName }}
          <span
            v-if="item.voucher_id || item.is_promo"
            class="promotion"
          > ({{ $t('promotion_item') }})</span>
        </span>
        <div v-if="courseItems">
          <ul :style="listStyle">
            <li
              v-for="(name, index) in courseItems"
              :key="index"
            >{{ name }}</li>
          </ul>
        </div>
        <div v-if="toppings">
          <ul :style="listStyle">
            <li
              v-for="(name, index) in toppings"
              :key="index"
            >+add: {{ name }}</li>
          </ul>
        </div>
        <div v-if="options">
          <ul :style="listStyle">
            <li
              v-for="(name, index) in options"
              :key="index"
            >{{ $t('option') }}: {{ name }}</li>
          </ul>
        </div>
        <div v-if="item.remarks">
          <span :style="remarksStyle"
          >{{ $t('remarks') }}: {{ item.remarks }}</span>
        </div>
      </v-flex>
      <v-flex
        xs2
        class="text-xs-right"
      >
        <span :style="nameStyle">{{ $n(amount, 'currency') }}</span>
        <span :style="presetDiscountPriceStyle" v-if="afterPresetDiscountPrice">{{ $n(afterPresetDiscountPrice, 'currency') }}</span>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import preset_discount from '../mixins/preset_discount'

export default {
  name: 'checkout-item-component',
  props: {
    item: {
      type: Object,
      default: () => null
    }
  },
  mixins: [preset_discount],
  computed: {
    ...mapGetters('config', [
      'theme', 'language'
    ]),
    ...mapGetters('auth', [
      'user'
    ]),
    listStyle () {
      return {
        listStyleType: 'none',
        paddingLeft: '0',
        color: this.theme.orders_name_color
      }
    },
    titleStyle () {
      return {
        color: this.theme.orders_title_color
      }
    },
    nameStyle () {
      let styles = {
        color: this.theme.orders_name_color
      };

      if (this.afterPresetDiscountPrice) {
        styles.textDecoration = 'line-through'
      }

      return styles;
    },
    presetDiscountPriceStyle () {
      return {
        color: this.theme.orders_name_color
      }
    },
    remarksStyle () {
      return {
        color: this.theme.cart_remarks_color,
        fontSize: '13px'
      }
    },
    amount () {
      if (this.item&& this.item.set_course_items.length === 0) {
        if (this.item.final_price) {
          return parseFloat(this.item.final_price) * this.item.quantity
        }
        return parseFloat(this.item.price ? this.item.price : this.item.final_price) * this.item.quantity
      }
      if (this.item && this.item.set_course_items.length > 0){
        let item_price = 0
        if (this.item.final_price) {
          item_price = parseFloat(this.item.final_price)
        }
        item_price =  parseFloat(this.item.price ? this.item.price : this.item.final_price)

        this.item.set_course_items.forEach(function (i){
          if (i.price_override) {
            item_price = item_price + parseFloat(i.price_override)
          }
        })
        return item_price * this.item.quantity
      }
      return 0
    },
    afterPresetDiscountPrice () {
      const presetDiscount = this.calculateAvailablePresetDiscount(this.item, this.user, this.item.quantity)

      if (!presetDiscount) {
        return null;
      }
      if (this.item && this.item.set_course_items.length === 0) {
        let price;
        if (this.item.final_price) {
          price = parseFloat(this.item.final_price)
          // return parseFloat(this.item.final_price) * this.item.quantity
        } else {
          price = parseFloat(this.item.price ? this.item.price : this.item.final_price);
          // return parseFloat(this.item.price ? this.item.price : this.item.final_price) * this.item.quantity
        }

        // if (presetDiscount) {
        //   this
        // }
        return presetDiscount
          ? this.calculateAfterPresetDiscountPriceByPrice(presetDiscount, price, this.item.quantity)
          : (price * this.item.quantity)
      } else if (this.item && this.item.set_course_items.length > 0){
        let item_price = 0
        if (this.item.final_price) {
          item_price = parseFloat(this.item.final_price)
        }
        item_price =  parseFloat(this.item.price ? this.item.price : this.item.final_price)

        this.item.set_course_items.forEach(function (i){
          item_price = item_price + parseFloat(i.price_override)
        })

        return presetDiscount
          ? this.calculateAfterPresetDiscountPriceByPrice(presetDiscount, item_price, this.item.quantity)
          : (item_price * this.item.quantity)
      }
      return 0
    },
    courseItems () {
      if (this.item.set_course_items.length > 0) {
        return this.item.set_course_items.map(item => item.name)
      }
      return null
    },
    toppings () {
      if (this.item.toppings.length > 0) {
        return this.item.toppings.map(item => item.name)
      }
      return null
    },
    options () {
      if (this.item.options.length > 0) {
        return this.item.options.map(item => item.name)
      }
      return null
    },
    itemName () {
      if (this.language !== 'en-SG') {
        return this.item.alternativeName || this.item.name
      }
      return this.item.name
    }
  }
}
</script>

<style scoped>
.name {
  font-weight: 700;
}
.promotion {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/CheckoutItem.vue